import * as React from "react"
import styled from 'styled-components';
import { Container } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image"

const StyledContainer = styled(Container)`

`

const RealTimeDatabase = () => {
    return (
        <StyledContainer>
            <div className="row pt-4">
                <div className="col-sm mw-100">
                    <StaticImage src="../../../images/real_time_database_co_vs_dropcontact.jpg" alt="Validate email address with Clearout's Email Verifier for accurate results and guaranteed email deliverability" placeholder="blurred" />
                </div>
                <div className="col-sm-6">
                    <p><span className="fw-bolder fs-5">Real-Time In-App Search</span></p>
                    <p>Clearout offers In-App real-time search functionality to enrich and build your prospect list better. Whereas, Dropcontact does not have a In-App search and hence it does not support real-time In-App prospect list building.</p>
                </div>
            </div>
        </StyledContainer>
    )
}

export default RealTimeDatabase;